define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    exports.computeList = function (specs) {
        return specs.reduce(function ($cur, spec) {
            return $cur.add(spec.$list.find(spec.sel));
        }, $());
    };
    function makePager($pager) {
        var specs = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            specs[_i - 1] = arguments[_i];
        }
        var prev = $pager.find('.left.paddle button');
        var next = $pager.find('.right.paddle button');
        var $data = $("#" + $pager.data('sync'));
        var getCurrent = function () { return parseInt($data.data('current')); };
        var getCount = function () { return exports.computeList(specs).length; };
        var setCurrent = function (x) {
            $data.data('current', x);
            $(exports.computeList(specs)[x]).click();
        };
        if (getCurrent() === 0) {
            prev.prop('disabled', 'disabled');
        }
        if (getCount() === 1) {
            next.prop('disabled', 'disabled');
        }
        prev.click(function (e) {
            e.preventDefault();
            e.stopPropagation();
            var cur = getCurrent() || getCount();
            var nextCur = cur - 1;
            if (nextCur >= 0) {
                setCurrent(nextCur);
                next.removeProp('disabled');
            }
        });
        next.click(function (e) {
            e.preventDefault();
            e.stopPropagation();
            var cur = getCurrent();
            var count = getCount();
            var nextCur = (cur + 1) % count;
            if (nextCur < count) {
                setCurrent(nextCur);
                prev.removeProp('disabled');
            }
        });
    }
    exports.makePager = makePager;
    function syncPager($pager, cur) {
        var specs = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            specs[_i - 2] = arguments[_i];
        }
        var prev = $pager.find('.left.paddle button');
        var next = $pager.find('.right.paddle button');
        var $data = $("#" + $pager.data('sync'));
        var getCurrent = function () { return parseInt($data.data('current')); };
        var getCount = function () { return exports.computeList(specs).length; };
        if (getCurrent() !== cur) {
            $data.data('current', cur);
        }
        if (getCount() > 1) {
            prev.removeProp('disabled');
            next.removeProp('disabled');
        }
        else {
            prev.prop('disabled', 'disabled');
            next.prop('disabled', 'disabled');
        }
    }
    exports.syncPager = syncPager;
    exports.syncCur = function ($pager, $cur) {
        var specs = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            specs[_i - 2] = arguments[_i];
        }
        var $list = exports.computeList(specs);
        var index = $list.index($cur);
        if (index >= 0) {
            syncPager.apply(null, [$pager, index].concat(specs));
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/pager.js
// module id = 86
// module chunks = 0